import { render } from "./PriceGroupList.vue?vue&type=template&id=c3a1425c&scoped=true&ts=true"
import script from "./PriceGroupList.vue?vue&type=script&lang=ts"
export * from "./PriceGroupList.vue?vue&type=script&lang=ts"

import "./PriceGroupList.vue?vue&type=style&index=0&id=c3a1425c&scoped=true&lang=scss"

import exportComponent from "D:\\YellowBeardProject\\Hermelin\\hermelinshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3a1425c"]])

export default __exports__